/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { useClient, useQuery } from "jsonapi-react";
import _ from "lodash";
import { useMutation } from "jsonapi-react";
import { useToasts } from "react-toast-notifications";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import ChangePassword from "../../components/common/ChangePassword/ChangePassword";
import { validatorModule } from "../../helpers/helpers";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import avatar from "../../assets/images/profileimagePlaceholder.jpg";
import CaptureImageComponent from "../../components/CaptureImageComponent/CaptureImageComponentWithCrop";
import { handleRefreshToken, logout } from "../../helpers/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { apiRoutes, VW_ROUTES } from "../../constants";
import LazyLoadedSelect from "../../components/LazyLoadedSelect/LazyLoadedSelect";
import axios from "axios";
import Loader from "../../components/common/Loader/Loader";
import { MdOutlineSave } from "react-icons/md";

const UserProfile = () => {
  const token = localStorage.getItem("access_token");

  const config = {
    headers: {
      Authorization: `JWT ${token}`,
      "content-type": "multipart/form-data",
    },
  };

  const initialState = {
    new_password1: "",
    new_password2: "",
  };

  const passwordValidation = [
    {
      field: "new_password1",
      isPassword: true,
      fieldName: "New Password",
    },
  ];

  const validationFormat = [
    ...passwordValidation,
    {
      field: "new_password2",
      isSameAs: {
        field: "new_password1",
        fieldName: "New Password",
      },
      isRequired: true,
      fieldName: "Confirm Password",
    },
  ];

  const history = useHistory();
  const { currentUser, manageLoader } = React.useContext(AppContext);
  const [avatarImage, setAvatarImage] = React.useState(
    currentUser?.avatar ? currentUser?.avatar : avatar
  );
  const [userDetails, setUserDetails] = useState({});
  const [userId, setUserId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [timeZoneUpdating, setTimeZoneUpdating] = useState(false);
  const [selectedTimeZone, setSelectedTimeZone] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    setAvatarImage(currentUser?.avatar ? currentUser?.avatar : avatar);
    getUserDetails();
  }, [currentUser]);

  const getUserDetails = () => {
    setIsLoading(true);
    const url = `${apiRoutes.userDetails.replace(
      "{userId}",
      currentUser?.user_id
    )}`;
    axios
      .get(url, config)
      .then((response) => {
        setUserDetails(response?.data?.data?.attributes);
        setUserId(response?.data?.data?.id);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    localStorage.setItem("userTz", userDetails?.userTz);
    setSelectedTimeZone({
      label: userDetails?.userTz,
      value: userDetails?.userTz,
    });
  }, [userDetails]);

  const handleImageError = () => {
    setAvatarImage(avatar);
  };
  const { addToast } = useToasts();
  const client = useClient();
  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  const [changePassword] = useMutation(["auth", "password", "change"], {
    client,
  });
  const { showModal, manageModal, setSessionTimeOut } =
    React.useContext(AppContext);
  const [errors, setErrors] = React.useState(null);
  const [passData, setPassData] = React.useState(initialState);
  const [imageModal, setImageModal] = React.useState(false);
  const [editStarted, setEditStarted] = useState(false);
  const [isLoaderActive, setLoaderActive] = useState(false);

  const handleLogoutUser = () => {
    logout();
    history.push(VW_ROUTES.LOGIN);
  };

  const onPassDataChange = (target) => {
    setPassData({
      ...passData,
      [target.name]: target.value,
    });
  };

  const {
    data: timeZones,
    isLoading: loading,
    error: errorInfo,
  } = useQuery(apiRoutes.timeZoneList, {
    client,
  });

  const handleFilterTimeZone = (data) => {
    setSelectedTimeZone(data);
    setIsDisabled(false);
  };

  const handleTokenUpdation = async () => {
    if (!(await handleRefreshToken())) {
      setSessionTimeOut(true);
    }
  };

  const updateTimezone = () => {
    setTimeZoneUpdating(true);
    let formData = new FormData();
    formData.append("timezone", selectedTimeZone.value);
    axios
      .put(`${apiRoutes.updateTimeZone}`, formData, config)
      .then(() => {
        localStorage.setItem("userTz", selectedTimeZone.value);
        setTimeZoneUpdating(false);
        setIsDisabled(true);
        addToast(DISPLAY_TEXTS.TIMEZONE_UPDATED, { appearance: "success" });
        handleTokenUpdation();
      })
      .catch(() => {
        setTimeZoneUpdating(false);
        addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "error" });
      });
  };

  const handleResetChangePasswordModalState = () => {
    setLoaderActive(false);
    setPassData(initialState);
    setErrors(null);
  };

  const handleChangePasswordModalClose = () => {
    handleResetChangePasswordModalState();
    manageModal(false);
  };

  const handlePasswordValidation = (isForm = false) => {
    const errorValidation = validatorModule(
      {
        new_password1: passData.new_password1,
        ...(isForm ? { new_password2: passData.new_password2 } : {}),
      },
      isForm ? validationFormat : passwordValidation
    );
    setErrors(errorValidation);
    if (
      errorValidation?.new_password1?.find(
        (validateItem) => validateItem?.isError
      ) ||
      _.size(errorValidation?.new_password2)
    ) {
      return false;
    } else {
      return true;
    }
  };

  useEffect(() => {
    if (!showModal) return;
    if (!editStarted && passData?.new_password1?.length) {
      setEditStarted(true);
    }
    handlePasswordValidation();
  }, [passData?.new_password1, editStarted, showModal]);

  const getPasswordErrorStatus = () =>
    errors?.new_password1?.length &&
    errors?.new_password1?.find((validateItem) => validateItem?.isError);

  const onChangePasswordSubmit = async () => {
    let isFormValid = handlePasswordValidation(true);
    if (isFormValid) {
      setLoaderActive(true);
      const { error, data } = await changePassword(passData);
      setLoaderActive(false);
      if (error) {
        addToast(error.detail, { appearance: "error" });
      } else if (data) {
        addToast(DISPLAY_TEXTS.PASSWORD_UPDATED, { appearance: "success" });
        handleChangePasswordModalClose();
        handleLogoutUser();
      }
    }
  };
  const managePhotoBooth = (status) => {
    setImageModal(status);
  };
  const refreshOnCaptureImage = () => {
    managePhotoBooth(false);
  };

  if (isLoading || Object.keys(userDetails).length === 0) {
    return <Loader />;
  } else {
    return (
      <>
        <ModalComponent
          show={imageModal}
          customClass="camModal"
          header={<b>Profile Picture</b>}
          content={
            imageModal ? (
              <CaptureImageComponent
                applicantId={userId}
                profileImages={[userDetails?.avatar]}
                status={imageModal}
                onPictureCapture={refreshOnCaptureImage}
              />
            ) : (
              ""
            )
          }
          hideFooter={true}
          onSubmitCallback={() => {
            setImageModal(false);
          }}
          onCloseCallback={() => {
            setImageModal(false);
          }}
        />
        <div className="row">
          <div className="col-12">
            <h1>Profile</h1>
            <button
              type="button"
              className="btn btn-secondary btn-sm float-right"
              onClick={() => {
                setErrors(null);
                setLoaderActive(false);
                setPassData(initialState);
                manageModal(true);
              }}
            >
              Change Password
            </button>
            <div className="separator mb-5"></div>
          </div>
        </div>
        <div className="row profile-holder">
          <div className="col-lg-12 col-md-12 mb-4">
            <div className="card">
              <div className="card-body">
                <div className="row mb-2">
                  <div className="col-12 col-md-4 col-lg-3  left-deck">
                    <div className="profile-cover">
                      <div className="image-holder">
                        <img
                          src={avatarImage}
                          onError={handleImageError}
                          alt="avatar"
                          className="profile-image card-img-top"
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center">
                      <button
                        type="button"
                        className="btn btn-secondary  mr-2 mt-2"
                        onClick={() => managePhotoBooth(true)}
                      >
                        <i className="simple-icon-camera"></i> Upload
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-8 col-lg-9 right-deck">
                    <div className="row ">
                      <div className="fieldValue font-weight-bold col-12">
                        <h4>{`${userDetails?.fullName}`}</h4>
                        <h5 className="capitalize-first-letter">
                          {currentUser.role_slug.replace(/-/g, " ")}
                        </h5>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-12 mail-info">
                        <p>
                          <i className="iconsminds-Envelope"></i>{" "}
                          <b> {userDetails?.email}</b>
                        </p>
                        {userDetails?.phone_number && (
                          <p className="phone">
                            <i className="iconsminds-Old-Telephone"></i>{" "}
                            <b> {userDetails?.phoneNumber}</b>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-12 col-md-8 col-lg-5 col-xl-5">
                        <span>Time Zone</span>
                        <div className=" d-flex align-items-center mt-2">
                          <LazyLoadedSelect
                            className="cutomSelect w-100"
                            classNamePrefix="react-custom-select"
                            name="timeZone"
                            onChange={handleFilterTimeZone}
                            options={timeZones?.regions}
                            placeholder="Select"
                            timezone={true}
                            isLoading={loading}
                            value={selectedTimeZone}
                          />
                          <button
                            type="button"
                            className="btn btn-secondary ml-2 position-relative"
                            disabled={isDisabled}
                            onClick={updateTimezone}
                          >
                            <MdOutlineSave fontSize={"1.5em"} />
                            {timeZoneUpdating && (
                              <span className="button-loader-container">
                                <div
                                  className="spinner-border spinner-border-sm ml-1 text-white"
                                  role="status"
                                ></div>
                              </span>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showModal === true && (
          <ModalComponent
            show={showModal}
            header={<b>Change Password</b>}
            content={
              <ChangePassword
                passData={passData}
                errors={errors}
                onInputChange={onPassDataChange}
                editStarted={editStarted}
              />
            }
            onSubmitCallback={onChangePasswordSubmit}
            onCloseCallback={handleChangePasswordModalClose}
            isSubmitDisabled={getPasswordErrorStatus()}
            isLoaderActive={isLoaderActive}
          />
        )}
      </>
    );
  }
};

export default UserProfile;
